(function () {
  const SELECTOR_TRIGGER = '.infinite-scroll-trigger';
  const SELECTOR_PRODUCT_GRID = '#product-grid'; // Dawn's default grid ID
  const SELECTOR_PAGINATION = '.pagination-wrapper';

  let isFetching = false;

  function init() {
    const trigger = document.querySelector(SELECTOR_TRIGGER);
    if (!trigger) return;

    // Hide traditional pagination
    document.querySelectorAll(SELECTOR_PAGINATION).forEach((el) => {
      el.style.display = 'none';
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isFetching) {
            loadNextPage(entry.target);
          }
        });
      },
      { rootMargin: '1200px' }
    );

    observer.observe(trigger);
  }

  async function loadNextPage(trigger) {
    const nextUrl = trigger.dataset.nextUrl;
    if (!nextUrl) return;

    isFetching = true;
    const spinner = trigger.querySelector('.infinite-scroll-spinner');
    if (spinner) spinner.style.display = 'flex';

    try {
      const response = await fetch(nextUrl);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Append new products
      const newProducts = doc.querySelector(SELECTOR_PRODUCT_GRID);
      const currentGrid = document.querySelector(SELECTOR_PRODUCT_GRID);

      if (newProducts && currentGrid) {
        // Append only the children (product cards), not the grid itself
        Array.from(newProducts.children).forEach((child) => {
          currentGrid.appendChild(child.cloneNode(true));
        });
      }

      // Check for next page
      const newTrigger = doc.querySelector(SELECTOR_TRIGGER);
      if (newTrigger && newTrigger.dataset.nextUrl) {
        trigger.dataset.nextUrl = newTrigger.dataset.nextUrl;
      } else {
        // No more pages — remove trigger
        trigger.remove();
        return;
      }

      // Update browser URL without reload (optional)
      const pageMatch = nextUrl.match(/page=(\d+)/);
      if (pageMatch) {
        const url = new URL(window.location);
        url.searchParams.set('page', pageMatch[1]);
        window.history.replaceState({}, '', url);
      }
    } catch (error) {
      console.error('Infinite scroll fetch error:', error);
    } finally {
      isFetching = false;
      if (spinner) spinner.style.display = 'none';
    }
  }

  // Run on initial load and after Shopify section re-renders (e.g. filtering)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after AJAX filtering in Dawn
  document.addEventListener('shopify:section:load', init);
})();